import { useWebSession } from "@switch/core";

export const Redirect = ({ processed }) => {
    const { GoToSessionURL } = useWebSession()

    if (processed) GoToSessionURL()

    return;

}